import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import _ from 'lodash';

import 'react-table/react-table.css';

import { render } from '../../lib/helpers';

class DataGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  getData() {
    const { data = [] } = this.props;
    return data || [];
  }

  getColumns() {
    const { columnHeaders = 'event', columns = [] } = this.props;
    const cleanColumns = _.map(columns, c => ({
      ...c,
      Header: !_.isUndefined(c.Header) ? c.Header : render({
        path: columnHeaders,
        value: c.id || c.accessor,
        html: false,
        safe: false,
      }),
      accessor: c.accessor,
      id: c.id || undefined,
      Cell: c.Cell ? c.Cell : p => render({
        path: c.path || c.accessor,
        value: p.value,
        html: false,
        safe: false,
        defaultValue: _.isUndefined(c.defaultValue) ? undefined : c.defaultValue,
      }),
    }));
    return cleanColumns || [];
  }

  render() {
    const {
      getTdProps,
      minRows,
      defaultPageSize,
      compactStyle,
      sorted,
      ...restProps
    } = this.props;

    let compactStyleString = '';
    if (compactStyle) {
      compactStyleString = 'compact';
    }

    return (
      <div className={`datagrid ${compactStyleString}`}>
        <ReactTable
          {...restProps}
          data={this.getData()}
          columns={this.getColumns()}
          showPaginationTop
          defaultPageSize={defaultPageSize}
          minRows={minRows}
          getTdProps={getTdProps}
          sorted={sorted}
        />
      </div>
    );
  }
}

DataGrid.propTypes = {
  data: PropTypes.instanceOf(Array),
  columns: PropTypes.instanceOf(Array),
  columnHeaders: PropTypes.string,
  getTdProps: PropTypes.func,
  minRows: PropTypes.number,
  defaultPageSize: PropTypes.number,
  compactStyle: PropTypes.bool,
  sorted: PropTypes.instanceOf(Array),
};
DataGrid.defaultProps = {
  data: [],
  columns: [],
  columnHeaders: 'eventHeaders',
  getTdProps: () => ({}),
  minRows: 0,
  defaultPageSize: 5,
  compactStyle: false,
  sorted: [],
};

export default DataGrid;



// WEBPACK FOOTER //
// ./src/views/Components/DataGrid.js